<template>
  <div>
    <p class="error_msg" v-if="errors.length === 1 && errors[0] === 'メールアドレスはすでに存在します'">
      前回お申込を中断されていませんか？ご入力いただいたメールアドレスでお客様情報の登録が済んでおります。<br>
      このあと決済を完了すると入塾いただける状態です。<br>
      こちらから
      <router-link :to="{ name: 'UsersSignIn'}">ログイン</router-link>
      すると以前ご登録いただいた情報で決済に進むことができます（マイページが開きます）。<br>
      パスワードは前回ご登録いただいたものです。もしお忘れの場合はこちらから
      <router-link :to="{ name: 'UsersNewPassword'}">再発行</router-link>
      できます。
    </p>
    <p class="error_msg" v-else v-for="e in errors" :key="e">{{ e }}</p>
  </div>
</template>

<script>
export default {
  props: {
    errors: []
  }
}
</script>
